module.exports = __webpack_public_path__ + "static/media/SCDream2.b183bdac.otf";